import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from 'react-router-dom/withRouter';
import PublicWebsiteNav from './components/PublicWebsiteNav';
import { ProfilePageOverrideNav } from './components/PublicWebsiteNav/components/ProfilePageOverrideNav';
import { isIOS, isAndroidChrome } from '../helpers/serverRenderingUtils';

export default function withVanityHeader(BaseComponent) {
  const mapStateToProps = ({ user: { user, hostName } }) => ({
    user,
    hostName,
  });

  class WithVanityHeader extends Component {
    // Static SSR data function
    static fetchData(props) {
      // delegate to wrapped static SSR function if it exists
      return BaseComponent.fetchData && BaseComponent.fetchData(props);
    }

    constructor(props, context) {
      super(props, context);
      this.state = {
        didMount: false,
      };
    }

    componentDidMount() {
      this.setState(() => ({
        didMount: true,
      }));
    }

    render() {
      const { user, hostName, ...props } = this.props;
      return [
        <BaseComponent key="vanityComponent" {...props} />,
        !user && (
          <ProfilePageOverrideNav
            key="vanityNav"
            isIOS={isIOS()}
            isAndroidChrome={isAndroidChrome()}
            didMount={this.state.didMount}
          />
        ),
      ];
    }
  }
  return withRouter(connect(mapStateToProps)(WithVanityHeader));
}
